<template>
  <div>
    <template v-if="$apollo.loading">
      <loading/>
    </template>

    <template v-else>
      <template v-if="homeResults.recentlyAddedAlbums.length">
        <div class="poly-mb-1-5">
          <div class="columns is-mobile is-variable is-1-mobile">
            <div class="column">
              <h1 class="title is-size-4 is-size-5-mobile has-text-weight-extra-bold">
                Recently added albums
              </h1>
              <h2 class="subtitle is-size-7 is-size-7-mobile has-text-grey-light has-text-weight-semibold">
                Albums that have been recently added to your collection.
              </h2>
            </div>

            <div class="column is-narrow has-text-right has-text-weight-semibold">
              <router-link
                v-bind:to="{ name: 'recently-added-albums' }"
                class="button is-small is-rounded is-outlined has-text-grey-light"
              >
                <span class="icon is-small">
                  <i class="mdi mdi-arrow-right"></i>
                </span>
                <span>View more</span>
              </router-link>
            </div>
          </div>

          <album-list v-bind:albums="homeResults.recentlyAddedAlbums"/>
        </div>
      </template>

      <template v-if="homeResults.recentlyPlayedAlbums.length">
        <div class="poly-mb-1-5">
          <div class="columns is-mobile is-variable is-1-mobile">
            <div class="column">
              <h1 class="title is-size-4 is-size-5-mobile has-text-weight-extra-bold">
                Recently played albums
              </h1>
            </div>

            <div class="column is-narrow has-text-right has-text-weight-semibold">
              <router-link
                v-bind:to="{ name: 'recently-played-albums' }"
                class="button is-small is-rounded is-outlined has-text-grey-light"
              >
                <span class="icon is-small">
                  <i class="mdi mdi-arrow-right"></i>
                </span>
                <span>View more</span>
              </router-link>
            </div>
          </div>

          <album-list v-bind:albums="homeResults.recentlyPlayedAlbums"/>
        </div>
      </template>

      <template v-if="homeResults.mostPlayedAlbums.length">
        <div class="poly-mb-1-5">
          <div class="columns is-mobile is-variable is-1-mobile">
            <div class="column">
              <h1 class="title is-size-4 is-size-5-mobile has-text-weight-extra-bold">
                Your most played albums
              </h1>
              <h2 class="subtitle is-size-7 is-size-7-mobile has-text-grey-light has-text-weight-semibold">
                You are burning these albums.
              </h2>
            </div>

            <div class="column is-narrow has-text-right has-text-weight-semibold">
              <router-link
                v-bind:to="{ name: 'most-played-albums' }"
                class="button is-small is-rounded is-outlined has-text-grey-light"
              >
                <span class="icon is-small">
                  <i class="mdi mdi-arrow-right"></i>
                </span>
                <span>View more</span>
              </router-link>
            </div>
          </div>

          <album-list v-bind:albums="homeResults.mostPlayedAlbums"/>
        </div>
      </template>

      <template v-if="homeResults.randomUnplayedAlbums.length">
        <div class="columns is-mobile">
          <div class="column">
            <h1 class="title is-size-4 is-size-5-mobile has-text-weight-extra-bold">
              Give these albums a chance
            </h1>
            <h2 class="subtitle is-size-7 is-size-7-mobile has-text-grey-light has-text-weight-semibold">
              A random selection of albums that you haven't played yet.
            </h2>
          </div>

          <div class="column is-narrow has-text-right has-text-weight-semibold">
          </div>
        </div>

        <album-list v-bind:albums="homeResults.randomUnplayedAlbums"/>
      </template>

      <template>
        <div class="poly-mb-1-5">
          <div class="columns is-mobile is-variable is-1-mobile">
            <div class="column">
              <h1 class="title is-size-4 is-size-5-mobile has-text-weight-extra-bold">
                Selected music for you
              </h1>
              <h2 class="subtitle is-size-7 is-size-7-mobile has-text-grey-light has-text-weight-semibold">
                Music that will follow your listening habits
              </h2>
            </div>
          </div>

          <div v-if="showSelectedMusic" class="columns is-multiline is-mobile is-variable is-3-desktop is-2-mobile">
            <random-album v-if="homeResults.randomAlbumCovers.length" v-bind:albums="homeResults.randomAlbumCovers"/>
            <most-played-tracks v-if="homeResults.mostPlayedTrackCovers.length" v-bind:tracks="homeResults.mostPlayedTrackCovers"/>
            <liked-tracks v-if="homeResults.likedTrackCovers.length" v-bind:tracks="homeResults.likedTrackCovers"/>
            <random-unplayed-tracks v-if="homeResults.randomUnplayedTrackCovers.length" v-bind:tracks="homeResults.randomUnplayedTrackCovers"/>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
  import Loading from '@/components/Loading'

  import AlbumList from '@/components/AlbumList'
  import RandomAlbum from '@/components/Home/RandomAlbum'
  import MostPlayedTracks from '@/components/Home/MostPlayedTracks'
  import LikedTracks from '@/components/Home/LikedTracks'
  import RandomUnplayedTracks from '@/components/Home/RandomUnplayedTracks'

  export default {
    name: 'Home',
    components: {
      Loading,
      AlbumList,
      RandomAlbum,
      MostPlayedTracks,
      LikedTracks,
      RandomUnplayedTracks
    },
    computed: {
      showSelectedMusic: function () {
        return(
          this.homeResults.randomAlbumCovers.length ||
          this.homeResults.mostPlayedTrackCovers.length ||
          this.homeResults.likedTrackCovers.length ||
          this.homeResults.randomUnplayedTrackCovers.length
        )
      }
    },
    apollo: {
      homeResults: {
        query: require('@/graphql/Home.gql'),
        update (data) {
          return data
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~bulma/sass/utilities/initial-variables";

  .button:hover {
    border-color: $grey-dark;
    color: $grey-dark
  }

  .button:hover > span {
    color: $grey-dark
  }
</style>
